import type { MaterialFormula } from "./types.js";
import { ceilSafe, resolveInput, round2 } from "./util.js";

/** ฝ้า T-Bar 60x60 ต้องมี width และ length เพื่อคำนวณ Main Tee */
export const ceilTbar: MaterialFormula = (input) => {
  const r = resolveInput(input);
  if (r.width === undefined || r.length === undefined) {
    throw new RangeError("CEIL_TBAR ต้องระบุ width และ length");
  }
  const { area, width, length, waste } = r;
  const perimeter = input.perimeter ?? 2 * (width + length);
  return [
    { key: "tbar_panel", name_th: "แผ่นฝ้า 60x60 ซม.", qty: ceilSafe((area / 0.36) * (1 + waste)), unit: "แผ่น", qty_basis: "area/0.36 x (1+waste)" },
    { key: "main_tee", name_th: "Main Tee 3.66 ม.", qty: (Math.floor(width / 1.22) + 1) * ceilSafe(length / 3.66), unit: "เส้น", qty_basis: "(floor(W/1.22)+1) x ceil(L/3.66)" },
    { key: "cross_tee_122", name_th: "Cross Tee 1.22 ม.", qty: ceilSafe(1.46 * area), unit: "เส้น", qty_basis: "1.46 x area" },
    { key: "cross_tee_061", name_th: "Cross Tee 0.61 ม.", qty: ceilSafe(0.73 * area), unit: "เส้น", qty_basis: "0.73 x area" },
    { key: "wall_angle", name_th: "Wall Angle", qty: round2(perimeter), unit: "ม.", qty_basis: "2(W+L)" },
    { key: "hanger", name_th: "Hanger Wire + Clips", qty: ceilSafe(area / 1.44), unit: "ชุด", qty_basis: "area/1.44" },
  ];
};
